import React from "react";
import { Modal } from "antd";

export const PopupModal = ({ isOpen, closeFn, title, subTitle, closeText }) => {
  return (
    <Modal
      centered
      open={isOpen}
      destroyOnClose={true}
      closable={false}
      footer={null}
      onCancel={closeFn}
      width={window.innerWidth <= 768 ? '95vw' : 520}
      className="responsive-popup-modal"
      bodyStyle={{
        padding: window.innerWidth <= 480 ? 15 : 24
      }}
    >
      <div className="p-5">
        <div className="success-modal" style={{ textAlign: 'center' }}>
          <i
            className="bi bi-check-circle-fill text-success"
            style={{ fontSize: "4rem" }}
          />
          <p className="lead mt-4">{title}</p>
          <p className="text-black-50">{subTitle}</p>
          {closeText && (
            <button
              className="btn btn-primary mt-4 w-75"
              onClick={closeFn}
            >
              {closeText}
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};
